import { useRef, useState } from "react";

export function Dropzone({ onFiles }: { onFiles: (files: File[]) => void }) {
  const input = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);

  const take = (list: FileList | null) => {
    const files = [...(list ?? [])];
    if (files.length > 0) onFiles(files);
  };

  return (
    <div
      className={`dropzone${over ? " dropzone--over" : ""}`}
      onDragOver={(event) => {
        event.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(event) => {
        event.preventDefault();
        setOver(false);
        take(event.dataTransfer.files);
      }}
    >
      <span className="dropzone__saucer" aria-hidden="true" />
      <p className="dropzone__lead">Drop a file to put it on the web.</p>
      <p className="dropzone__hint meta">
        It uploads straight to storage and comes back as a link.
      </p>
      <button className="button" type="button" onClick={() => input.current?.click()}>
        Choose a file
      </button>
      <input
        ref={input}
        className="visually-hidden"
        type="file"
        multiple
        onChange={(event) => {
          take(event.target.files);
          event.target.value = "";
        }}
      />
    </div>
  );
}
